import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const localConfig: ApplicationConfig = {
  apiUrl: 'http://localhost:3000',
  apiKey: '75dd554a-2b38-4774-807d-a3d1a870c9e7',
  stage: Stage.LOCAL,
  sheetId: '1CNmHugwnAfmcFjMf1okeUJBsoUtFh7o-ktd7qXrcyEU',
  wpAdminUrl: 'https://dev.skin-seoul.com/wp-admin/',
  adminUrl: 'http://localhost:5173',
};
